import { basePath, userUpPath } from "./config";
import axios from "axios";

export function signInApi(data) {
  const url = `${basePath}/authpr/signin`;

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      //console.log(result);
      return result;
    })
    .catch((err) => {
      //return { ok: false, message: err.message };
      return err.message;
    });
}

export function recoverApi(data) {
  const url = `${basePath}/authpr/recover`;

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      //console.log(result);
      return result;
    })
    .catch((err) => {
      //return { ok: false, message: err.message };
      return err.message;
    });
}

export function recoverPassApi(cod) {
  const url = `${basePath}/authpr/recoverpass?cod=${cod}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      //console.log(result);
      return result;
    })
    .catch((err) => {
      //return { ok: false, message: err.message };
      return err.message;
    });
}

export function recoverCodeApi(code, data) {
  const url = `${basePath}/authpr/recovercode?cod=${code}`;

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      //console.log(result);
      return result;
    })
    .catch((err) => {
      //return { ok: false, message: err.message };
      return err.message;
    });
}

export function getUsersApi(token) {
  const url = `${basePath}/userpr/getusers`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getUserApi(token, id) {
  const url = `${basePath}/userpr/getuser?id=${id}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getUsersActiveApi(token, status) {
  const url = `${basePath}/userpr/getusersactive?active=${status}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function getSupplersUserApi(token, id) {
  const url = `${basePath}/userpr/getsupplieruser?id=${id}`;

  const params = {
    method: "GET",
    //body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function updateUserApi(token, user, userId) {
  const url = `${basePath}/userpr/upduser?id=${userId}`;
  //let data = { user: user, target: targetKey };
  const params = {
    method: "POST",
    body: JSON.stringify(user),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function updateUserInfoApi(token, user, userId) {
  const url = `${basePath}/userpr/upduserinfo?id=${userId}`;
  //let data = { user: user, target: targetKey };
  const params = {
    method: "POST",
    body: JSON.stringify(user),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function activateUserApi(token, userId, status) {
  const url = `${basePath}/userpr/activateuser?id=${userId}`;

  const params = {
    method: "POST",
    body: JSON.stringify({ active: status }),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };
  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function addUserApi(token, data) {
  const url = `${basePath}/userpr/adduser`;

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function uploadTemplateUserApi(token, fileList) {
  const url = `${basePath}/userpr/uploadtemplate`;

  const bodyFormData = new FormData();
  bodyFormData.append("file", fileList[0]);

  return axios({
    method: "POST",
    url: url,
    data: bodyFormData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    },
  })
    .then((response) => {
      return response.data;
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function downloadTemplateUserApi() {
  const url = `${userUpPath}/Plantilla_cargue_usuarios_masivo.xlsx`;
  return axios({
    method: "get",
    url: url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/octet-stream" })
      );
      link.download = "Plantilla_cargue_usuarios_masivo.xlsx";

      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        window.URL.revokeObjectURL(link);
      }, 200);
      return "OK";
    })
    .catch((error) => {
      return "ERROR";
    });
}
